import { render, staticRenderFns } from "./MetodologiaCrud.vue?vue&type=template&id=76324043&scoped=true&"
import script from "./MetodologiaCrud.vue?vue&type=script&lang=js&"
export * from "./MetodologiaCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76324043",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
